import React from "react";
import Input from "../../input/inputNormal";
import { BlockBase, HeadlineHeader } from "../../parts/blockBase";

/** 売買情報 */
export default class Block3 extends BlockBase {
    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            headlineId: "010103",
        };
    }


    render() {
        const { hideBlockClass, params } = this.renderCommon();

        // 非表示判定の場合、null(react的な表示なし)を返す
        if (this.dohide(this.props.pageState.hidingHeadline)) { return null; }

        return (
            <div className={`dataList dataList__accordion ${hideBlockClass}`}>
                <div className="dataList-header">
                    <div className="dataList-header-title">売買情報</div>
                    <HeadlineHeader onClick={this.handleHide} hide={this.state.hide} />
                </div>
                <div className="dataList-body">
                    <table className="dataTable">
                        <tbody>
                            <tr>
                                <th className="dataTable-title dataTable-title__w120">売買価格<br />（税抜）</th>
                                <td className="dataTable-body dataTable-body__w355">
                                    <div className="dataTableUnit">
                                        <Input id="ID_TOR00008" name="TOR00008" value={this.props.pageState.TOR00008} {...params} length="w145" />
                                        <div className="dataTableUnit-text">円</div>
                                    </div>
                                </td>
                                <td className="dataTable-body dataTable-body__w355 dataTable-body dataTable-body__leftborder " colSpan="2">&nbsp;</td>
                            </tr>
                            <tr>
                                <th className="dataTable-title dataTable-title__w120">消費税</th>
                                <td className="dataTable-body dataTable-body__w355">
                                    <div className="dataTableUnit">
                                        <Input id="ID_TOR00009" name="TOR00009" value={this.props.pageState.TOR00009} {...params} length="w145" />
                                        <div className="dataTableUnit-text">円</div>
                                    </div>
                                </td>
                                <td className="dataTable-body dataTable-body__w355 dataTable-body__leftborder " colSpan="2">&nbsp;</td>
                            </tr>
                            <tr>
                                <th className="dataTable-title dataTable-title__w120">売買価格<br />（税込）</th>
                                <td className="dataTable-body dataTable-body__w355">
                                    <div className="dataTableUnit">
                                        <Input id="ID_TOR00010" name="TOR00010" value={this.props.pageState.TOR00010} {...params} length="w145" />
                                        <div className="dataTableUnit-text">円</div>
                                    </div>
                                </td>
                                <th className="dataTable-title dataTable-title__w120">手付金</th>
                                <td className="dataTable-body dataTable-body__w355">
                                    <div className="dataTableUnit">
                                        <Input id="ID_TOR00011" name="TOR00011" value={this.props.pageState.TOR00011} {...params} length="w145" />
                                        <div className="dataTableUnit-text">円</div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}